import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconCamera = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "silver",
		d: "M10 12.667c1.473 0 2.667-1.194 2.667-2.667 0-1.473-1.194-2.667-2.667-2.667-1.473 0-2.667 1.194-2.667 2.667 0 1.473 1.194 2.667 2.667 2.667z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "silver",
		d: "M7.5 1.667L5.975 3.333H3.333c-.916 0-1.666.75-1.666 1.667v10c0 .917.75 1.667 1.666 1.667h13.334c.916 0 1.666-.75 1.666-1.667V5c0-.917-.75-1.667-1.666-1.667h-2.642L12.5 1.667h-5zm2.5 12.5c-2.3 0-4.167-1.867-4.167-4.167S7.7 5.833 10 5.833 14.167 7.7 14.167 10 12.3 14.167 10 14.167z"
	})]
});
export default SvgIconCamera;
